export default "__VITE_ASSET__66612eb3__"